// extracted by mini-css-extract-plugin
export default {"pageError":"nlLJ9"};